import React, { ReactElement, useEffect, useState } from "react";
import styled from "styled-components";

type Props = {
  readonly src: string;
  readonly onEnded: () => void;
};

type StyledProps = {
  readonly isVisible: boolean;
};
const StyledVideo = styled.video<StyledProps>`
  object-fit: contain;
  object-position: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  bottom: 0;
  top: 0;
  pointer-events: none;
  display: ${({ isVisible }: StyledProps) => (isVisible ? "block" : "none")};
`;

export const Video = ({ src, onEnded }: Props): ReactElement => {
  const [isVideoVisible, setVideoVisible] = useState(false);

  useEffect(() => setVideoVisible(!!src), [src]);

  const handleVideoEnded = () => {
    setVideoVisible(false);
    onEnded();
  };

  return (
    <StyledVideo
      preload="auto"
      autoPlay
      isVisible={isVideoVisible}
      onEnded={handleVideoEnded}
      src={src}
    />
  );
};
